// ============================================
// VOLUNTEER MODULE - SIDEBAR
// Includes light/dark mode toggle
// ============================================

import React from "react";
import { useTheme } from "./ThemeContext";

const NAV_ITEMS = [
  { id: "dashboard",  icon: "📊", label: "Dashboard" },
  { id: "events",     icon: "📅", label: "Events" },
  { id: "volunteers", icon: "👥", label: "Volunteers" },
  { id: "assign",     icon: "🗂️", label: "Duty Assignment" },
  { id: "attendance", icon: "✅", label: "Attendance" },
  { id: "reports",    icon: "📈", label: "Reports" },
  { id: "users",      icon: "🔐", label: "Users", requiresPerm: "manage_users" },
];

export default function Sidebar({ activePage, onNavigate, activeEvent, can }) {
  const { C, isDark, toggleTheme } = useTheme();

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%", background: C.navBg, borderRight: `1px solid ${C.border}`, transition: "background 0.3s" }}>

      {/* Logo */}
      <div style={{ padding: "20px 20px 16px", borderBottom: `1px solid ${C.border}`, flexShrink: 0 }}>
        <div style={{ fontSize: 15, fontWeight: 800, color: C.accent }}>⚡ VolunteerHub</div>
        <div style={{ fontSize: 10, color: C.muted, marginTop: 3, letterSpacing: "0.5px" }}>VOLUNTEER HUB v1.0</div>
      </div>

      {/* Theme Toggle */}
      <div style={{ padding: "12px 14px", borderBottom: `1px solid ${C.border}`, flexShrink: 0 }}>
        <button onClick={toggleTheme}
          style={{
            width: "100%", padding: "8px 12px",
            background: isDark ? C.accentSoft : C.orangeSoft,
            border: `1px solid ${isDark ? C.accent : C.orange}44`,
            borderRadius: 10, cursor: "pointer",
            display: "flex", alignItems: "center", justifyContent: "space-between",
            transition: "all 0.3s",
          }}>
          <span style={{ fontSize: 12, fontWeight: 700, color: isDark ? C.accent : C.orange }}>
            {isDark ? "🌙 Dark Mode" : "☀️ Light Mode"}
          </span>
          {/* Toggle pill */}
          <div style={{
            width: 36, height: 20, borderRadius: 99,
            background: isDark ? C.accent : C.orange,
            position: "relative", transition: "background 0.3s",
          }}>
            <div style={{
              position: "absolute",
              top: 2, left: isDark ? 18 : 2,
              width: 16, height: 16, borderRadius: "50%",
              background: "#fff", transition: "left 0.3s",
            }} />
          </div>
        </button>
      </div>

      {/* Active Event Badge — synced with Dashboard's classification */}
      {activeEvent && activeEvent.name && (
        <div
          style={{
            margin: "12px 12px 0", padding: "10px 12px",
            background: C.greenSoft, border: `1px solid ${C.green}44`, borderRadius: 10, flexShrink: 0
          }}>
          <div style={{ display:"flex", alignItems:"center", gap:6 }}>
            <span style={{ width:6, height:6, borderRadius:"50%", background:C.green, animation:"pulse 2s infinite" }} />
            <div style={{ fontSize: 10, color: C.green, fontWeight: 700, letterSpacing: "0.5px" }}>ACTIVE EVENT</div>
          </div>
          <div style={{ fontSize: 12, color: C.text, fontWeight: 600, marginTop: 3 }}>{activeEvent.name}</div>
          {activeEvent.dates && <div style={{ fontSize: 10, color: C.muted, marginTop: 2 }}>{activeEvent.dates}</div>}
        </div>
      )}

      {/* Nav Items */}
      <nav style={{ flex: 1, padding: "10px 10px", overflowY: "auto" }}>
        {NAV_ITEMS.filter(item => !item.requiresPerm || (can && can(item.requiresPerm))).map(item => (
          <button key={item.id} onClick={() => onNavigate(item.id)}
            style={{
              display: "flex", alignItems: "center", gap: 10,
              width: "100%", padding: "10px 12px", borderRadius: 10,
              border: "none", cursor: "pointer",
              background: activePage === item.id ? C.accentSoft : "transparent",
              color: activePage === item.id ? C.accent : C.muted,
              fontSize: 13, fontWeight: activePage === item.id ? 700 : 500,
              marginBottom: 2, textAlign: "left", transition: "all 0.2s",
            }}>
            <span style={{ fontSize: 15 }}>{item.icon}</span>
            {item.label}
            {activePage === item.id && (
              <div style={{ marginLeft: "auto", width: 5, height: 5, borderRadius: "50%", background: C.accent }} />
            )}
          </button>
        ))}
      </nav>
    </div>
  );
}